import { render, staticRenderFns } from "./LicenseSelector.vue?vue&type=template&id=0ef2d53a"
import script from "./LicenseSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenseSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports